import script from "./Cam.vue?vue&type=script&setup=true&lang=js"
export * from "./Cam.vue?vue&type=script&setup=true&lang=js"

import "./Cam.vue?vue&type=style&index=0&id=39806647&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39806647"]])

export default __exports__